export default __webpack_public_path__ + "static/media/type_0.7b4a21a5.svg";